module.exports = __webpack_public_path__ + "img/ltkhalloween-1x.39f4592.jpg";